import formErrorsHandler from "api/global/form-errors-handler";
import {
    SYSTEM_LISTS_LOADING,
    SYSTEM_LISTS_ERRORS,
    FETCH_COMMODITIES_SUCCESS,
    SYSTEM_LISTS_GET_EMPLOYMENT_TYPES,
    SYSTEM_LISTS_GET_EMPLOYMENT_STATUS,
    SYSTEM_LISTS_GET_LANGUAGES,
    SYSTEM_LISTS_GET_APPLIED_FOR,
    SYSTEM_LISTS_GET_WORK_HOURS_AVAILABILITY,
    SYSTEM_LISTS_GET_TRAVEL_TYPES
} from "actions/types";

import {
    getCommodityList,
    requestGetEmploymentTypeItems,
    requestGetEmploymentStatusItems,
    requestGetLanguagesItems,
    requestGetAppliedFor,
    requestGetHoursOfWorkAvailability,
    requestGetTravelTypes
} from "api/systemListsApi";

export const setSystemListsLoading = () => ({
    type: SYSTEM_LISTS_LOADING
});

export const setSystemListsError = payload => ({
    type: SYSTEM_LISTS_ERRORS,
    payload
});

export const fetchCommodities = (includeInactive = true) => dispatch => {
    dispatch(setSystemListsLoading());
    getCommodityList(includeInactive)
        .then(response => {
            dispatch({
                type: FETCH_COMMODITIES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const getEmploymentTypeItems = (includeInactive = true) => dispatch => {
    dispatch(setSystemListsLoading());
    requestGetEmploymentTypeItems(includeInactive)
        .then(response => {
            dispatch({
                type: SYSTEM_LISTS_GET_EMPLOYMENT_TYPES,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const getEmploymentStatusItems = (includeInactive = true) => dispatch => {
    dispatch(setSystemListsLoading());
    requestGetEmploymentStatusItems(includeInactive)
        .then(response => {
            dispatch({
                type: SYSTEM_LISTS_GET_EMPLOYMENT_STATUS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const getLanguagesItems = (includeInactive = true) => dispatch => {
    dispatch(setSystemListsLoading());
    requestGetLanguagesItems(includeInactive)
        .then(response => {
            dispatch({
                type: SYSTEM_LISTS_GET_LANGUAGES,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const getAppliedFor = (includeInactive = true) => dispatch => {
    dispatch(setSystemListsLoading());
    requestGetAppliedFor(includeInactive)
        .then(response => {
            dispatch({
                type: SYSTEM_LISTS_GET_APPLIED_FOR,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const getHoursOfWorkAvailability = (includeInactive = true) => dispatch => {
    dispatch(setSystemListsLoading());
    requestGetHoursOfWorkAvailability(includeInactive)
        .then(response => {
            dispatch({
                type: SYSTEM_LISTS_GET_WORK_HOURS_AVAILABILITY,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};


export const getTravelTypes = (includeInactive = true) => dispatch => {
    dispatch(setSystemListsLoading());
    requestGetTravelTypes(includeInactive)
        .then(response => {
            dispatch({
                type: SYSTEM_LISTS_GET_TRAVEL_TYPES,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};
